<template>
  <div class="page-attendees">
    <Attendee :user="user" v-for="user in list" :key="user.id" />
  </div>
</template>

<script>
import Attendee from '@/components/attendees/Attendee'
import getUsers from '@/mixins/getUsers'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Participants',
  components: { Attendee },
  mixins: [getUsers],
  created() {
    if (this.summer2020) {
      this.getAttendees2020()
    }
  },
  computed: {
    role() {
      return this.$route.meta.role || 'expert'
    },
    list() {
      return this.users[this.role]
      // return this.summer2020 ? this.attendees2020 : this.attendees
    },
    summer2020() {
      return this.$route.meta.summer2020
    },
    attendees() {
      if (!this.users?.attendee) return []
      return Array.from(this.users.attendee)
        .filter(({ visible }) => visible)
        .sort((a, b) => (a.last_name < b.last_name ? -1 : 1))
    },
    ...mapState('users', ['attendees2020']),
  },
  methods: {
    ...mapActions('users', ['getAttendees2020']),
  },
}
</script>

<style lang="scss">
#content.page-attendees {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px 20px;
  padding: 22px 20px;

  @include PC {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
    padding: 0;
  }
}
</style>
